import { observer } from 'mobx-react';
import React from 'react';

import DrawerLayout from 'components/Views/Creative/Drawers/DrawerLayout';
import store from 'stores/RootStore';
import { PanelViews } from 'types/PanelViews';

import BundleSummaryRow from './BundleSummaryRow';

function BundlesDrawer() {
  const store_creative = store.creative;
  if (!store_creative) return null;

  const bundles = store_creative.bundles.allAvailable;

  const handleOnClose = () => {
    store_creative.setPanel(PanelViews.NONE);
  };

  return (
    <DrawerLayout
      open={store_creative.displayPanel === PanelViews.BUNDLES}
      onClose={handleOnClose}
      title="Bundles"
    >
      {bundles.map((bundle) => (
        <BundleSummaryRow bundle={bundle} key={bundle.id} />
      ))}
    </DrawerLayout>
  );
}

export default observer(BundlesDrawer);
